import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import gsap from 'gsap';

export default {
  init() {
    // Header mobile burger stack
    const $navigation = $('.navigation');
    const $mobileBurgerStack = $navigation.find('.mobile-burger-stack');
    $mobileBurgerStack.on("click", () => {
      $navigation.toggleClass("open");

      if ($navigation.hasClass("open")) {
        disableBodyScroll($navigation[0]);
      } else {
        enableBodyScroll($navigation[0]);
        clearAllBodyScrollLocks();
      }
    })

    // Footer partners carousel
    const $partnersCarousel = $('.page-footer .partners-carousel');
    $partnersCarousel.flickity({
      cellAlign: 'center',
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      percentPosition: false,
      autoPlay: 1500,
      pauseAutoPlayOnHover: true,
      imagesLoaded: true,
    });

    // Flexible Content
    $(".four-column-icon-text-link").each(function () {
      $(this).find(".column").matchHeight();
    });

    $(".faq-accordion").each(function () {
      const $faqContainers = $(this).find(".faq-container");
      $faqContainers.each(function () {
        const $this = $(this);  // This refers to each faq container one

        const $answer = $this.find(".answer");
        gsap.set($answer, { height: "auto" });

        let animation = gsap.from($answer, {
          height: 0,
          duration: 0.25,
          ease: "power1.inOut",
        });
        animation.reverse();

        const $question = $this.find(".question");
        $question.on("click", () => {
          $this.toggleClass("open");

          if ($this.hasClass("open")) {
            animation.play();
          } else {
            animation.reverse();
          }
        });
      });
    });

    $(".image-carousel").each(function () {
      const $carousel = $(this).find(".carousel");

      $carousel.flickity({
        // options
        // cellAlign: 'center',
        // contain: true,
        prevNextButtons: false,
        pageDots: false,
        lazyLoad: 1,
      });

      const $left = $(this).find(".carousel-controls .left");
      $left.on("click", () => {
        $carousel.flickity('previous');
      });

      const $right = $(this).find(".carousel-controls .right");
      $right.on("click", () => {
        $carousel.flickity('next');
      });

      const $numbersIndex  = $(this).find(".carousel-controls .numbers .index");
      $carousel.on('change.flickity', function(event, index) {
        $numbersIndex.text(index + 1);

        if (index <= 0) {
          $left.prop('disabled', true);
        } else {
          $left.prop('disabled', false);
        }

        if (index >= $carousel.data('flickity').cells.length - 1) {
          $right.prop('disabled', true);
        } else {
          $right.prop('disabled', false);
        }
      });
    });

    // Expand textarea on focus
    $("textarea[name=your-message]").each(function () {
      const $this = $(this);
      $this.on("focus", () => {
        // increase height
        $this.css("height", "200px");
      });

      $this.on("blur", () => {
        // increase height
        $this.css("height", "40px");
      });
    });
  },
  finalize() { },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js